/**
 * Who may change a comment on a task or lead thread. Mirrors the server:
 * editing a comment, deleting it, or deleting one of its files is the
 * author's alone (`assertCanRemove` in backend/src/lib/commentAttachments.ts).
 */

/** A file on a comment, as the thread shows it (tasks and leads alike). */
export interface CommentAttachmentItem {
  url: string;
  name: string;
  contentType: string;
}

interface Viewer {
  id: string;
}

export function canEditComment(viewer: Viewer | null, authorId: string | null): boolean {
  return !!viewer && authorId === viewer.id;
}

export function canRemoveComment(viewer: Viewer | null, authorId: string | null): boolean {
  return !!viewer && authorId === viewer.id;
}

interface RemovableComment {
  content: string;
  attachments?: unknown[] | null;
}

/** What the confirm says before a whole comment goes (web and mobile). */
export function removeCommentPrompt(comment: RemovableComment) {
  const files = comment.attachments?.length ?? 0;
  return {
    title: 'Ștergi comentariul?',
    message:
      files > 0
        ? `Comentariul și ${files === 1 ? 'fișierul atașat' : `cele ${files} fișiere atașate`} se șterg. Fișierele ajung în coșul din Google Drive.`
        : 'Comentariul se șterge definitiv.',
    confirmLabel: 'Șterge',
    danger: true,
  };
}

/** What the confirm says before one file goes; the last one takes the comment. */
export function removeAttachmentPrompt(comment: RemovableComment, name: string) {
  const last = !comment.content.trim() && (comment.attachments?.length ?? 0) === 1;
  return {
    title: 'Ștergi atașamentul?',
    message: last
      ? `„${name}” e singurul conținut al comentariului, așa că se șterge tot comentariul. Fișierul ajunge în coșul din Google Drive.`
      : `„${name}” dispare din comentariu și ajunge în coșul din Google Drive.`,
    confirmLabel: 'Șterge',
    danger: true,
  };
}
